import { Navigate } from "react-router-dom";
import { PageContainer } from "@/components/flowly/PageContainer/PageContainer";
import { useLanguage } from "@/contexts/LanguageContext";
import { useIsMobile } from "@/hooks/use-mobile";

const Accessibility = () => {
  const { t } = useLanguage();
  const isMobile = useIsMobile();

  if (isMobile) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageContainer className="py-16">
        <h1 className="text-4xl font-bold text-foreground mb-8">{t.accessibility.title}</h1>
        <p className="text-muted-foreground mb-8">{t.accessibility.lastUpdated}</p>

        <div className="space-y-8 text-foreground">
          <section>
            <h2 className="text-2xl font-semibold mb-4">{t.accessibility.section1Title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.accessibility.section1Content}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t.accessibility.section2Title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.accessibility.section2Content}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t.accessibility.section3Title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.accessibility.section3Content}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t.accessibility.section4Title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.accessibility.section4Content}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t.accessibility.section5Title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.accessibility.section5Content}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t.accessibility.section6Title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.accessibility.section6Content}
            </p>
          </section>
        </div>
    </PageContainer>
  );
};

export default Accessibility;
